<template>
    <div class="left_panel product_list_vtwo">
        <div
            class="panel_head_wrap d-flex align-items-end justify-content-between"
        >
            <div class="panel_heading">
                <h2>Favorite</h2>
                <div class="subhead">Manage your favourite products</div>
            </div>

            <div
                class="panel_head_right upload_img_panel fav_panel_right_checkbox d-flex align-items-center"
            >
                <div class="align-self-center d-flex">
                    <div
                        class="select_checkbox form-check pl_8 py_6 pr-0"
                        v-show="
                            selectedIds &&
                            selectedIds.filter((element) => element).length > 0
                        "
                    >
                        <label class="checkbox_custom font_size_20"
                            >Select All
                            <input
                                type="checkbox"
                                v-model="selectedAll"
                                @change="selectAll"
                            />
                            <span class="checkmark"></span>
                        </label>
                    </div>
                </div>

                <div class="delet_icon">
                    <a
                        v-show="
                            selectedIds &&
                            selectedIds.filter((element) => element).length > 0
                        "
                        v-tooltip="'Delete!'"
                        href="javascript:void(0)"
                        data-toggle="modal"
                        :data-target="'#delete-resource-all'"
                        class="ml_30"
                    >
                        <span class="d-flex align-items-center">
                            <span class="bin_icon"
                                ><img
                                    alt="img"
                                    src="/maincss/images/icons/delete_dark.svg"
                            /></span>
                            <span class="font_size_20">Delete</span>
                        </span>
                    </a>
                    <DeleteResource
                        :key="'product-delete-all'"
                        :target="'delete-resource-all'"
                        :path="'/delete/favorite-product/'"
                        :post_data="{ ids: selectedIds }"
                        :method="'post'"
                        @updatelist="getAllFavoriteProducts()"
                        :message="'Product removed from your favorite list.'"
                    />
                </div>
            </div>
        </div>

        <div class="row mt_30">
            <div
                class="col-sm-6 col-md-4 col-lg-3 col-xl-2"
                v-for="(favorite, key) in favorite_product_list"
                :key="'product' + key"
            >
                <div class="product">
                    <div
                        class="| capitalize product_image d-flex justify-content-center bg_primary_light_white py_30 position-relative"
                    >
                        <DisplayProductImage
                            :product="favorite.NewProduct"
                            :classValue="'img-fluid product_image_main full_contain_img'"
                        />

                        <DiscountOffer :product="favorite.NewProduct" />

                        <div class="hover_buttons d-inline-flex">
                            <router-link
                                :to="{
                                    path:
                                        '/product-details/' +
                                        favorite.NewProduct.id
                                }"
                                class="addcart_button bg_primary_orange py_18 w-100 text-center mx_10 text_white heading5 d-flex justify-content-center align-items-center"
                            >
                                <img
                                    src="/maincss/images/cart_icon.svg"
                                    alt=" "
                                    class="mr_16"
                                />
                                Add to cart
                            </router-link>
                            <a
                                href="javascript:void(0)"
                                data-toggle="modal"
                                :data-target="'#delete-resource-' + favorite.id"
                                class="favorite_button bg_primary_orange py_18 px_18"
                                ><img
                                    src="/maincss/images/favorite_delete.svg"
                                    alt=" "
                            /></a>
                        </div>

                        <div
                            class="form-check pl-0 py_6 d-flex justify-content-center align-items-center"
                        >
                            <label class="checkbox_custom">
                                <input
                                    type="checkbox"
                                    :true-value="favorite.id"
                                    v-model="selectedIds[key]"
                                    @change="checkChange" /><span
                                    class="checkmark"
                                ></span
                            ></label>
                        </div>
                    </div>
                    <div class="product_content mt_22 product_color_dot">
                        <h4 class="product-sku">
                            <router-link
                                :to="{
                                    name: 'product_details_new',
                                    params: {
                                        id_of_product: favorite.NewProduct.id
                                    }
                                }"
                                >{{
                                    favorite.NewProduct.product_number
                                        | capitalize
                                }}</router-link
                            >
                        </h4>
                        <h5 class="heading5">
                            {{ favorite.NewProduct.name | capitalize }}
                        </h5>
                    </div>
                </div>
            </div>

            <DeleteResource
                v-for="(favorite, key) in favorite_product_list"
                :key="'product-delete' + key"
                :target="'delete-resource-' + favorite.id"
                :path="'/delete/favorite-product/'"
                :post_data="{ ids: favorite.id }"
                :method="'post'"
                @updatelist="getAllFavoriteProducts()"
                :message="'Product removed from your favorite list.'"
            />
        </div>
        <div
            class="col-md-12 col-lg-12 col-xl-12 align-self-center text-center"
            v-show="favorite_product_list.length < 1"
        >
            <div class="product mb-0">
                <h3>You have no items in your favorite list. Start adding!</h3>
            </div>
        </div>
        <div class="preloader" v-show="isBusy">
            <div class="preloader-body">
                <svg width="40" height="40" viewBox="0 0 40 40">
                    <polygon
                        class="rect"
                        points="0 0 0 40 40 40 40 0"
                    ></polygon>
                </svg>
            </div>
        </div>
    </div>
</template>
<script>
import ApiService from "@/common/api.service";
import DiscountOffer from "@/components/DiscountOfferNew";
import DisplayProductImage from "@/components/DisplayProductImageNew";
import DeleteResource from "@/components/DeletePopup";

export default {
    /* eslint-disable */
    name: "Favorite",
    /* eslint-enable */
    components: {
        DiscountOffer,
        DisplayProductImage,
        DeleteResource
    },
    data() {
        return {
            favorite_product_list: [],
            isBusy: false,
            selectedIds: [],
            selectedAll: false,
            all_colors_list: []
        };
    },
    mounted() {
        this.getAllColors();
        this.getAllFavoriteProducts();
        document.body.classList.add("bg_primary_light_white");
        /* eslint-disable */
        $(function () {
            $("#item2").click(function () {
                $("#submenu2").slideToggle(500);
            });
        });
        /* eslint-enable */
    },
    methods: {
        checkChange() {
            var _this = this;
            let isAll_checked = true;
            _this.favorite_product_list.forEach((element) => {
                if (isAll_checked) {
                    isAll_checked = _this.selectedIds.includes(element.id);
                }
            });
            _this.selectedAll = isAll_checked ? true : false;
        },
        selectAll() {
            var _this = this;
            _this.selectedIds = [];
            if (_this.selectedAll) {
                _this.favorite_product_list.forEach((element) => {
                    // console.log(element.id);
                    _this.selectedIds.push(element.id);
                });
            }
        },
        getAllFavoriteProducts() {
            var _this = this;
            _this.isBusy = true;
            new Promise(() => {
                ApiService.post("/home-allfavorite-products")
                    .then(({ data }) => {
                        _this.favorite_product_list = data.favorite;
                        _this.favorite_product_list =
                            _this.favorite_product_list.filter(
                                (element) => element.NewProduct
                            );
                        let favIds = _this.favorite_product_list.map(
                            (ele) => ele.id
                        );

                        _this.selectedIds = _this.selectedIds.filter(
                            (element) => favIds.includes(element)
                        );

                        _this.favorite_product_list.forEach((favorite) => {
                            let color_ids = favorite.NewProduct.color_ids
                                ? JSON.parse(favorite.NewProduct.color_ids)
                                : [];
                            favorite.NewProduct.colors =
                                this.all_colors_list.filter((color) =>
                                    color_ids.includes(color.id)
                                );
                        });
                        _this.isBusy = false;
                    })
                    .catch(({ response }) => {
                        _this.isBusy = false;
                        console.log(response);
                    });
            });
        },
        deleteFavoriteProduct(id) {
            var _this = this;
            new Promise(() => {
                ApiService.post("/delete/favorite-product", { ids: id })
                    .then(({ data }) => {
                        console.log(data);
                        if (data.success) {
                            _this.getAllFavoriteProducts();
                            _this.$toast.error(
                                "product removed from your favorite list.",
                                {
                                    position: "top-right"
                                }
                            );
                        }
                    })
                    .catch(({ response }) => {
                        console.log(response);
                    });
            });
        },
        getAllColors() {
            return new Promise((resolve, reject) => {
                ApiService.post("/all-colors", {
                    attributes: ["id", "name", "hex", "swatches"]
                })
                    .then(({ data }) => {
                        this.all_colors_list = data.colors;
                        resolve(data);
                    })
                    .catch((response) => {
                        console.log(response);
                        reject(response);
                    });
            });
        }
    }
};
</script>
